import React, { useEffect, useState } from 'react';
import { v4 } from 'uuid';
import { View } from 'react-native';
import { Icon } from 'react-native-elements';
import GifySelectBox from './GifySelectBox';
import { validateUrl } from './RTIHelpers';
import Colors from '../../../../constants/Colorsv2';
import { Text, TouchableOpacity } from '../../../../globalComponents/NativeOverrides';
import CldCustUploadLgRestApi from '../../helpers/CldUploader';
import { social_getLinkPreview } from '../../../../store/actionsv1/social';
import { URLMetadataProps } from '../../../../store/types/soc_svc'; 
import TagOrdersModal from '../TagOrdersModal';
import { OrderProps } from '../../../../store/types/mk_svc';
import { link_getLinkType, link_getYoutubeEmbedId } from './helpers';

type RTIToolbarProps = {
    selected_orders: string[]
    onImageUpload: (obj:any) => void
    onVideoUpload: (obj:any) => void
    onLinkCreate: (url:string, link_preview:URLMetadataProps|undefined) => void
    onToolSelect: (tool:string) => void
    onTagOrders: (orders:string[]) => void
}

const RTIToolbar = ({ onImageUpload, onVideoUpload, onLinkCreate, onToolSelect, onTagOrders, selected_orders }:RTIToolbarProps) => {
    const [ gifVisible, setGifVisible ] = useState(false)
    const [ tag_order_visible, setTagOrderVisible ] = useState(false);

    
    const handleUpload = (obj:any) => {
        if(obj.resource_type === 'image'){
            console.log(obj)
            if(!onImageUpload){ return }
            return onImageUpload(obj)
        }
        if(obj.resource_type === 'video'){
            if(!onVideoUpload){ return }
            return onVideoUpload({ ...obj, video_source: 'local' })
        }
    }

    const handleLinkSelect = async() => {
        if(!onLinkCreate){ return }
        const enteredURL = window.prompt('Enter the URL of the link:')
        if(!enteredURL || enteredURL === ''){return alert('Invalid URL')}
        const { url, error, message } = validateUrl(enteredURL)
        if(error){ return alert('Invalid URL') }

        const link_type = link_getLinkType(url)
        if(link_type === 'youtube' && onVideoUpload){
            let embed_id = link_getYoutubeEmbedId(url)
            return onVideoUpload({ resource_type: 'video', url, video_source: 'youtube', embed_id, public_id:embed_id })
        }
        const link_preview = await social_getLinkPreview(url)
        return onLinkCreate(url, link_preview)
    }

    const handleToolSelect = async(tool:'image'|'bold'|'gif'|'list'|'link') => {
        switch(tool){
            case 'link':
                
            case 'gif': return setGifVisible(true)
            default: return
        }
    }

    const handleGifSelect = (gif:any) => {
        setGifVisible(false)
        let image = gif.images['original']
        if(!image){ return }
        onImageUpload({
            type: 'giphy',
            url: image.webp,
            resource_type: 'image',
            height:image.height,
            width:image.width
        })
    }

    return (
        <View>
            <View style={{ flexDirection:'row', alignItems:'center', borderRadius: 2, backgroundColor: Colors.shades.white, shadowColor: "rgba(0, 0, 0, 0.06)", shadowOffset: { width: 0, height: 10 },  shadowRadius: 10, shadowOpacity: 1 }}>
                <TouchableOpacity style={{flex:1/7, padding:10}} onPress={() => console.log('bold')}>
                    <Icon name='bold' type='feather' color={Colors.shades.black} size={16} />
                </TouchableOpacity>
                <View style={{flex:1/7, padding:10}}>
                    <CldCustUploadLgRestApi public_id={v4()} onFinishUpload={(obj:any) => handleUpload(obj)}/>
                </View>
                <TouchableOpacity style={{flex:1/7, padding:10}} onPress={() => handleLinkSelect('link')}>
                    <Icon name='link' type='feather' color={Colors.shades.black} size={16} />
                </TouchableOpacity>
                <TouchableOpacity style={{flex:1/7, padding:10}} onPress={() => console.log('mention')}>
                    <Icon name='at-sign' type='feather' color={Colors.shades.black} size={16} />
                </TouchableOpacity>
                <TouchableOpacity style={{flex:1/7, padding:10}} onPress={() => setTagOrderVisible(true)}>
                    <Icon name='tag' type='feather' color={Colors.shades.black} size={16} />
                </TouchableOpacity>
                <TouchableOpacity style={{flex:1/7, padding:10}} onPress={() => setGifVisible(true)}>
                    <Text size={14} color={Colors.brand.midnight} textAlign='center' weight='semibold'>GIF</Text>
                </TouchableOpacity>
                <View style={{flex:1/7}}/>
            </View>
            <GifySelectBox isVisible={gifVisible} gifSelect={handleGifSelect} closeModal={() => setGifVisible(false)}/>
            <TagOrdersModal init_orders={selected_orders} isVisible={tag_order_visible} onTagOrders={(orders) => onTagOrders(orders)} closeModal={() => setTagOrderVisible(false)} />
        </View>
        
    )
}

export default RTIToolbar